<template>
  <div class="user-info-box">
    <!-- <div class="user-img" @click="goUserInfo">
      <img :src="userInfo.HeadPortraitUrl ? userInfo.HeadPortraitUrl : require('@/assets/icon/defaultHead.png')" alt="">
    </div> -->
    <div class="nickname-title">
      <h4 class="nickname" @click="goUserInfo">{{userInfo.Nick | filterNick}}
        <i class="iconfont icon-xiangzuo1"></i>
      </h4>
    </div>
    <div class="user-info-tag" v-if="userInfo.IsBuyLimit || userInfo.IsTALimit">
      <template v-if="userInfo.IsBuyLimit">
        <span
          v-if="userInfo.BuyLimitDayNumber"
          class="tag"
          @click="violationTagClick($event)">限制购买至{{userInfo.BuyLimitRemoveDate | formatOverTime}}<i class="iconfont icon-xiangzuo1"></i>
        </span>
        <span
          v-else
          class="tag"
          @click="violationTagClick($event)">限制购买中<i class="iconfont icon-xiangzuo1"></i>
        </span>
      </template>
      <template v-if="userInfo.IsTALimit">
        <span
          v-if="userInfo.LimitDayNumber"
          class="tag"
          @click="violationTagClick($event)">提现限制至{{userInfo.TALimitRemoveDate | formatOverTime}}<i class="iconfont icon-xiangzuo1"></i>
        </span>
        <span
          v-else
          class="tag"
          @click="violationTagClick($event)">提现限制中<i class="iconfont icon-xiangzuo1"></i>
        </span>
      </template>
    </div>
    <div class="user-button">
      <button class="btn" @click="userLevel">{{userInfo.UserLevel | filterLevel}}</button>
      <button class="btn" @click="freeCard">免单卡 {{userInfo.GetQtyNoUsed || 0}} 张</button>
      <div
        :class="{'amount-item-badage': true, 'badage-big': waitGetFreeCard > 99}"
        v-if="waitGetFreeCard > 0">{{waitGetFreeCard > 99 ? '99+' : waitGetFreeCard}}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  props: {
    waitGetFreeCard: {
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    goUserInfo () {
      this.$emit('goUserInfo')
    },
    userLevel () {
      this.$emit('userLevel')
    },
    freeCard () {
      this.$emit('freeCard')
    },
    violationTagClick (e) {
      e.stopPropagation()
      this.$emit('violationTagClick')
    }
  },
  filters: {
    filterNick (val) {
      if (!val) return '----'
      if (val.length > 5) return val.substring(0, 5) + '...'
      return val
    },
    formatOverTime (val) {
      if (!val) return '----'
      return moment(val).format('M月D日')
    },
    filterLevel (val) {
      if (val === 1) return 'V1会员'
      else if (val === 2) return 'V2会员'
      else if (val === 3) return 'V3会员'
      else return '--会员'
    }
  }
}
</script>

<style scoped>
  .user-info-box{
    position: relative;
    width: 100%;
    background: #ffffff;
    box-shadow: 0 0 2px 0 #f5f5ff;
  }
  .user-info-box .user-img{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -30px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 2px 10px 0 #ccc;
    z-index: 2;
  }
  .user-info-box .user-img img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .nickname-title{
    text-align: center;
    padding-top: 40px;
  }
  .nickname{
    display: inline-block;
    text-align: center;
    font-size: 15px;
    cursor: pointer;
  }
  .nickname .iconfont{
    font-size: 10px;
    color: #c8c8cd;
    vertical-align: middle;
  }
  .user-button{
    position: relative;
    margin: 0 auto;
    padding: 10px 0;
    width: 58%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .user-button .btn{
    width: 95px;
    height: 26px;
    line-height: 24px;
    font-size: 12px;
    background: #ffffff;
    border: 1px solid #dedede;
    border-radius: 15px;
  }
  .user-button .btn:first-child{
    color: #d8b46e;
    border-color: #d8b46e;
  }
  .user-button .btn:active{
    background: #f2f2f2;
  }
  .user-info-tag{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 5px;
  }
  .user-info-tag .tag{
    display: inline-block;
    background: #ff0000;
    border-radius: 3px;
    color: #fff;
    font-size: 13px;
    box-sizing: border-box;
    padding: 1px 5px;
    margin-right: 5px;
  }
  .user-info-tag .iconfont{
    font-size: 12px;
  }
  /* dadge */
  .amount-item-badage{
    position: absolute;
    top: 10%;
    right: -7px;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    font-size: 12px;
    background: #f44336;
    color: #fff;
    border-radius: 50%;
  }
  .badage-big{
    width: 28px;
    border-radius: 15px;
  }
  @media screen and (max-width: 320px) {
    .user-button{
      width: 66%;
    }
  }
</style>
